// A database "permission denied" (SQLSTATE 42501, HTTP 403 from PostgREST) is not an expired session: the
// freelancer role simply cannot read that resource. ra-supabase's checkError logs the user out on any 403, so
// these errors are turned into a plain Error (no status) with a clear message instead.
export const PERMISSION_MESSAGE =
  "No tienes permiso para ver esto: lo administra el dueño del CRM.";

interface MaybeDbError {
  code?: unknown;
  body?: { code?: unknown; message?: unknown } | null;
  message?: unknown;
}

export const isPermissionDenied = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const e = error as MaybeDbError;
  if (e.code === "42501" || e.body?.code === "42501") return true;
  const message = String(e.body?.message ?? e.message ?? "");
  return /permission denied for (table|view|function|relation|sequence|schema)/i.test(
    message,
  );
};

export const friendlyPermissionError = (error: unknown): unknown =>
  isPermissionDenied(error) ? new Error(PERMISSION_MESSAGE) : error;

/** Wraps every method of a data provider so permission errors never reach checkError as a 403. */
export const withFriendlyPermissionErrors = <T extends object>(
  provider: T,
): T =>
  Object.fromEntries(
    Object.entries(provider).map(([name, value]) => [
      name,
      typeof value === "function"
        ? async (...args: unknown[]) => {
            try {
              return await value.apply(provider, args);
            } catch (error) {
              throw friendlyPermissionError(error);
            }
          }
        : value,
    ]),
  ) as T;
